import { HttpParams } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Examination, ExaminationList } from '../../model/examination.model';

export enum ExaminationTypes {
    SET_Examination = '[Examination] Set Examination',
    GET_Examination = '[Examination] Get Examination',
    GET_Examination_URL = '[Examination] Get Examination FROM URL',
    GET_Examination_SUCCESS = '[Examination] Get Examination Success',
    GET_Examination_FAILURE = '[Examination] Get Examination Failure',
}

export const GetExamination = createAction(
    ExaminationTypes.GET_Examination,
    props<{ params: HttpParams }>()
)

export const GetExaminationfromurl = createAction(
    ExaminationTypes.GET_Examination_URL,
    props<{ url: string }>()
)

export const GetExaminationSuccess = createAction(
    ExaminationTypes.GET_Examination_SUCCESS,
    props<{ payload: ExaminationList }>()
)

export const GetExaminationFailure = createAction(
    ExaminationTypes.GET_Examination_FAILURE,
)

export const SetExamination = createAction(
    ExaminationTypes.SET_Examination,
    props<{ examination: Examination }>()
)